export const fileIconType = {
  FILL_ICON : 'FILL_ICON',
  LABEL_ICON: 'LABEL_ICON',
  LINE_ICON: 'LINE_ICON'
}
